import React from 'react'
import { Query } from 'react-apollo'
import MY_USER_INFO from '../../gql/queries/myUserInfo'

export default ({ children }) => {
  return <Query query={MY_USER_INFO}>{children}</Query>
}
